import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { PerformanceTableResponse } from "../../../_models";

@Injectable({
  providedIn: "root",
})
export class OverviewProductReturnRequestsService extends DashboardService {
  route = "returns_dashboard/performance_by_product";
  protected reportType = ReportTypes.RETURN_RETENTION;
  protected group = 'product';
  protected data: BehaviorSubject<PerformanceTableResponse> = new BehaviorSubject<PerformanceTableResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }
}
